import { PipesModule } from './../comum/filtros/pipes/pipes.module';
import { UsuarioService } from './usuario.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { routing } from './../rotas';
import { ComumModule } from './../comum/comum.module';

import { CadastroUsuarioComponent } from './cadastro-usuario/cadastro-usuario.component';
import { ListarUsuariosComponent } from './listar-usuarios/listar-usuarios.component';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { AuthService } from '../auth/auth.service';
import { CookieService } from 'angular2-cookie/services/cookies.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    ComumModule,
    NgxPaginationModule,
    PipesModule,
    routing,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ConfirmDialogModule
  ],
  declarations: [CadastroUsuarioComponent, ListarUsuariosComponent],
  providers: [UsuarioService, ConfirmationService, AuthService, CookieService],
  exports: [CadastroUsuarioComponent, ListarUsuariosComponent]
})
export class UsuarioModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/usuario/usuario.module.ts